import { jsonp } from '@ifeng-fe/ui_base';
import mockData from '@src/common/midterm/mockData';
import pageConfig from '../mobile/index/config';

/** 企业微信/coopdoc 转 JSONP 开票接口 */
const MIDTERM_JSONP_URL =
    'https://shankapi.ifeng.com/feedflow/coopdoc/doc_c0052f4f14572665fb858d4d2482a6f1/info/mycallback';

/**
 * 拉取中期选举开票数据（2014-like：{ timestamp, states:[House,Senate,Gov] }）
 * 失败时回落本地 mock，保证页面可预览。
 */
export const getMidtermData = async () => {
    try {
        const res = await jsonp(MIDTERM_JSONP_URL, {
            jsonpCallback: 'mycallback',
            cache: Date.now(),
            timeout: 10000,
        });

        if (res && res.code === 0 && res.data && Array.isArray(res.data.states)) {
            return res.data;
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('[usmidterm2026] API failed, using mock', e);
    }

    return mockData;
};

export { MIDTERM_JSONP_URL };

const DOCS = pageConfig.allData.transferV3.map(([label, , , docId]) => [label.split(':')[0], docId]);

let requestId = 0;

const loadDoc = (docId, name) => {
    const callbackName = `usmidterm2026_${name}_${requestId++}`;

    return jsonp(`https://shankapi.ifeng.com/feedflow/coopdoc/${docId}/info/${callbackName}`, {
        jsonpCallback: callbackName,
        cache: false,
    });
};

/** 按 config.js 的文档重新拉取页面数据。单个失败时保留当前这份。 */
export const refreshContent = current =>
    Promise.all(
        DOCS.map(async ([key, docId]) => {
            try {
                const res = await loadDoc(docId, key);
                if (res && res.code === 0 && res.data) return [key, res.data];
            } catch (e) {
                // 保留当前数据
            }
            return [key, current[key]];
        }),
    ).then(entries => entries.reduce((next, [key, value]) => ({ ...next, [key]: value }), {}));
